"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMoneySmall = function SvgMoneySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.975 12.68h2.042c.836 0 1.512.64 1.512 1.435 0 .793-.676 1.435-1.512 1.435H9.343c-.402 0-.732.313-.732.694 0 .382.33.695.732.695h1.921v1.366c0 .382.33.695.732.695.402 0 .732-.313.732-.695V16.94h.297c1.64 0 2.975-1.267 2.975-2.824 0-1.558-1.335-2.825-2.975-2.825h-2.042c-.836 0-1.512-.641-1.512-1.435s.676-1.435 1.512-1.435h3.61c.402 0 .732-.313.732-.695 0-.381-.33-.694-.732-.694h-1.857V5.695c0-.382-.33-.695-.732-.695-.402 0-.732.313-.732.695v1.343h-.297C9.335 7.038 8 8.305 8 9.863c.008 1.55 1.343 2.816 2.975 2.816z"
  }));
};

SvgMoneySmall.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgMoneySmall.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgMoneySmall;
exports["default"] = _default;
module.exports = exports.default;